import { render, staticRenderFns } from "./Experiences.vue?vue&type=template&id=2ae269fe&scoped=true&"
import script from "./Experiences.vue?vue&type=script&lang=js&"
export * from "./Experiences.vue?vue&type=script&lang=js&"
import style0 from "./Experiences.vue?vue&type=style&index=0&id=2ae269fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae269fe",
  null
  
)

export default component.exports